import type { BlogPageProps } from 'lib/queries/blog';
import React from 'react';
import Navbar from './navbar';
import { useWordPressContext } from 'contexts/wordpress-provider';

const CategoriesNavbar: React.FC<{
  categories: BlogPageProps['categories'];
  displayH1?: boolean;
}> = ({ categories, displayH1 }) => {
  const { translations, blogPage } = useWordPressContext();

  return (
    <Navbar
      classNameWrap="pt-6"
      title={translations['Topics']}
      items={[
        {
          name: translations['All topics'],
          uri: blogPage?.uri ? blogPage.uri : '/blog/',
        },
        ...categories.map(({ link, ...rest }) => {
          return {
            ...rest,
            uri: link,
          };
        }),
      ]}
      displayH1={displayH1}
      size="small"
      isCategory={true}
    />
  );
};

export default CategoriesNavbar;
